import { axios } from './config';

//  获取appkey
export function getAppKey(params) {
  return axios.get('/fluorite_app_msg/list_all', params);
}

//  编辑基本信息
export function addAppKey(params) {
  return axios.post('/fluorite_app_msg/update_save', params, true);
}

//  请求获取token
export function getAppToken(params) {
  return axios.post('https://open.ys7.com/api/lapp/token/get', params, true)
}
/********************************   设备信息  **************************/
//  设备列表获取
export function getDevList(params) {
  return axios.get('/fluorite_equipment/list_all', params);
}

//  编辑设备
export function editDevice({ id, ...params}) {
  if (id) {
    return axios.post('/fluorite_equipment/update', { id, ...params}, true);
  } else {
    return axios.post('/fluorite_equipment/save', params, true);
  }
}

//  查询设备详情  - 失效接口
export function deviceInfo(params) {
  return axios.get(`/fluorite_equipment/info`, params);
}

//  删除设备
export function deleteDevice(id) {
  return axios.post(`/fluorite_equipment/delete/${id}`);
}

/********************************   摄像头  **************************/

//  摄像头列表
export function cameraList(params) {
  return axios.get('/fluorite_camera/list_all', params);
}

//  获取设备下的摄像头列表
export function deviceCameraList(params) {
  return axios.get('/fluorite_equipment/camera_list_all', params);
}

//  编辑摄像头
export function editCamera({ id, ...params}) {
  if (id) {
    return axios.post('/fluorite_camera/update', { ...params, id }, true);
  } else {
    return axios.post('/fluorite_camera/save', params, true);
  }
}

//  摄像头详情
export function cameraInfo(params) {
  return axios.get('/fluorite_camera/save', params);
}

//  删除摄像头
export function deleteCamera(id) {
  return axios.post(`/fluorite_camera/delete/${id}`);
}

//  摄像头分页查询
export function cameraPageList(params) {
  return axios.post(`/fluorite_equipment/camera_page_list`, params, true);
}